import { API_BASE } from 'shared/constants/Api'

export const PAYMENTS_CREATE = `${API_BASE}/api/v2/payments/`
export const PAYMENT = ({id}) => `${API_BASE}/api/v2/payments/${id}/`
